import {
  IconCalendarAlt,
  IconShieldCheck,
  IconFileSearchAlt,
  IconFire,
  IconEuroCircle,
} from '@maia/icons';
import { ClaimDto } from '@maia/shared';
import {
  cardStyles,
  SectionWithHeader,
  Spec,
  SpecList,
  Typography,
} from '@maia/ui';
import { formatDate } from '@maia/utils';
import { Link } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

type BasicClaimInformationProps = {
  claim: ClaimDto;
};

export function BasicClaimInformation(props: BasicClaimInformationProps) {
  const { claim } = props;

  return (
    <SectionWithHeader title="Basic claim details">
      <div
        className={twMerge(
          cardStyles({ variant: 'flat' }),
          'p-20 flex gap-x-12',
        )}
      >
        <SpecList className="grow">
          <Spec
            className="grid grid-cols-2"
            title="Product"
            icon={IconShieldCheck}
            value={claim.insurance.title}
          />
          <Spec
            className="grid grid-cols-2"
            title="Polisnummer"
            icon={IconFileSearchAlt}
            value={
              <Link
                to="/insurances/$guid"
                params={{ guid: claim.insurance.guid }}
              >
                <Typography
                  variant="body-xs"
                  weight="medium"
                  className="text-info300 text-nowrap"
                >
                  {`#${claim.insurance.reference}`}
                </Typography>
              </Link>
            }
          />
          <Spec
            className="grid grid-cols-2"
            title="Type schade"
            icon={IconFire}
            value={claim.cause}
          />
        </SpecList>
        <SpecList className="grow">
          <Spec
            className="grid grid-cols-2"
            title="Claimbedrag"
            icon={IconEuroCircle}
            value={`€${claim.claimedAmount}`}
          />
          <Spec
            className="grid grid-cols-2"
            title="Schade datum"
            icon={IconCalendarAlt}
            value={formatDate(claim.occurredAt)}
          />
        </SpecList>
      </div>
    </SectionWithHeader>
  );
}
